<h2 mat-dialog-title class="away-dialog-title">
  <mat-icon class="away-title-icon">{{ (isLoginFlow || isResetFlow) ? 'lock' : 'schedule' }}</mat-icon>
  {{ isResetFlow ? 'Reset MPIN' : (!isMpinAdded ? 'Set Your MPIN' : 'Set Away Status') }}
</h2>

<mat-dialog-content class="away-dialog-content" [class.reset-mpin-flow]="isResetFlow">
  <ng-container *ngIf="!isMpinAdded; else awayOptionsBlock">
    <p class="away-dialog-subtitle">
      <ng-container *ngIf="isLoginFlow; else notLoginFlow">
        Welcome! Set a 4-digit MPIN — you'll use it to unlock your screen when you return from a break.
      </ng-container>
      <ng-template #notLoginFlow>
        <ng-container *ngIf="isResetFlow; else awayMpinHint">
          Enter a new 4-digit MPIN. You'll use it to unlock your screen when you return from a break.
        </ng-container>
        <ng-template #awayMpinHint>
          Set a 4-digit MPIN to continue — you'll need it to unlock your screen when you return from a break.
        </ng-template>
      </ng-template>
    </p>

    <div class="form-field mpin-setup-block">
      <mat-label *ngIf="!isResetFlow">Set MPIN</mat-label>
      <div class="otp-input-group">
        <input
          #mpinBox0
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-box"
          [value]="mpinDigits[0]"
          (keypress)="allowOnlyNumbers($event)"
          (input)="onMpinDigitInput($event, 0, mpinBox1)"
          (keydown)="onMpinDigitKeydown($event, 0, null)"
        />
        <input
          #mpinBox1
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-box"
          [value]="mpinDigits[1]"
          (keypress)="allowOnlyNumbers($event)"
          (input)="onMpinDigitInput($event, 1, mpinBox2)"
          (keydown)="onMpinDigitKeydown($event, 1, mpinBox0)"
        />
        <input
          #mpinBox2
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-box"
          [value]="mpinDigits[2]"
          (keypress)="allowOnlyNumbers($event)"
          (input)="onMpinDigitInput($event, 2, mpinBox3)"
          (keydown)="onMpinDigitKeydown($event, 2, mpinBox1)"
        />
        <input
          #mpinBox3
          type="text"
          inputmode="numeric"
          maxlength="1"
          class="otp-box"
          [value]="mpinDigits[3]"
          (keypress)="allowOnlyNumbers($event)"
          (input)="onMpinDigitInput($event, 3, null)"
          (keydown)="onMpinDigitKeydown($event, 3, mpinBox2)"
        />
      </div>
      <div class="otp-error-wrapper">
        <span
          class="otp-error"
          *ngIf="mpinControl.touched && mpinControl.hasError('required')"
        >
          MPIN is required
        </span>
        <span
          class="otp-error"
          *ngIf="mpinControl.touched && mpinControl.hasError('pattern')"
        >
          MPIN must be exactly 4 digits
        </span>
      </div>
    </div>
  </ng-container>

  <ng-template #awayOptionsBlock>
    <p class="away-dialog-subtitle">Choose a reason — your session will be locked and tracked.</p>

    <div class="away-grid">
      <button
        *ngFor="let option of awayOptions"
        class="away-card"
        [class.selected]="showOtherReason && option.key === 'other'"
        mat-ripple
        (click)="selectOption(option)">
        <span class="away-card-icon" [style.background-color]="option.color">
          <mat-icon>{{ option.icon }}</mat-icon>
        </span>
        <span class="away-card-info">
          <span class="away-card-label">{{ option.label }}</span>
          <span class="away-card-sub">Lock &amp; track</span>
        </span>
      </button>
    </div>

    <div class="other-reason-container" #otherReasonBlock *ngIf="showOtherReason">
      <mat-label>Please specify your reason</mat-label>
      <textarea
        class="other-reason-textarea"
        rows="1"
        minlength="3"
        maxlength="500"
        placeholder="Type your reason here..."
        [formControl]="otherReasonControl"
        (blur)="onOtherReasonBlur()"
        autofocus></textarea>
      <div class="other-reason-footer">
        <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('required')" class="error-msg">
          Please provide a reason
        </mat-error>
        <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('minlength')" class="error-msg">
          Reason must be at least 3 characters
        </mat-error>
        <mat-error *ngIf="otherReasonControl.touched && otherReasonControl.hasError('maxlength')" class="error-msg">
          Reason cannot exceed 500 characters
        </mat-error>
        <span class="char-count">{{ otherReasonControl.value.length }}/500</span>
      </div>
    </div>

    <!-- Reminder-style recap of today's tasks/calendar, read-only -->
    <div class="away-overview-panel">
      <app-today-overview></app-today-overview>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="away-dialog-actions">
  <button *ngIf="!isLoginFlow" mat-button mat-dialog-close class="away-cancel-btn">Cancel</button>
  <button
    *ngIf="!isMpinAdded"
    mat-flat-button
    color="primary"
    class="away-save-mpin-btn"
    (click)="saveMpin()">
    {{ isResetFlow ? 'Reset MPIN' : 'Save & Continue' }}
  </button>
  <button
    *ngIf="isMpinAdded && showOtherReason"
    mat-flat-button
    color="primary"
    class="away-save-mpin-btn"
    [disabled]="otherReasonControl.invalid"
    (click)="confirmOtherReason()">
    Confirm &amp; Lock
  </button>
</mat-dialog-actions>